import { render, staticRenderFns } from "./AssignmentsTable.vue?vue&type=template&id=8603a0a2&"
import script from "./AssignmentsTable.vue?vue&type=script&lang=js&"
export * from "./AssignmentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports